//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ReagentMixDrawer from "./modules/ReagentMixDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryUserTreeList } from '@/api/api';
export default {
  name: 'ReagentMixList',
  mixins: [JeecgListMixin],
  components: {
    ReagentMixDrawer: ReagentMixDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/reagent/mix',
      pageTitle: '试剂配制',
      userTree: [],
      //人员信息
      // 表头
      isorter: {
        column: 'mix_time',
        order: 'desc'
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'productName',
        colName: 'product_id',
        title: '试剂产品',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '配制人员',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'mixReason_dictText',
        colName: 'mix_reason',
        title: '配制原因',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'mixTime',
        colName: 'mix_time',
        title: '配制时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'mixNum',
        colName: 'mix_num',
        title: '配制数量',
        align: 'center',
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {
    this.loadTreeList();
  },
  computed: {},
  methods: {
    /**
     * 时间筛选
     * @param value
     * @param mixTime
     */
    onDateSdata: function onDateSdata(value, mixTime) {
      this.queryParam.stime = mixTime;
    },
    // 用户树下拉
    loadTreeList: function loadTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    }
  }
};